__turbopack_context__.v({
  "container": "PhotoTips-module-scss-module__e7IBkq__container",
  "imageContainer": "PhotoTips-module-scss-module__e7IBkq__imageContainer",
  "list": "PhotoTips-module-scss-module__e7IBkq__list",
});
